﻿export default class JsControl {
    constructor(rootURL, target, mapControl, resourcesHandler, classId, action, modalWrapper) {
        this.rootURL = rootURL;
        this.target = target;
        this.mapControl = mapControl;
        this.resourcesHandler = resourcesHandler;
        this.classId = classId;
        this.action = action;
        this.elementId = 'map-action-' + this.classId + '-' + this.action.Id;
        this.visible = false;
        this.init();
    }

    init() {
        this.target.append(this._getActionButtonTemplate());
        document.getElementById(this.elementId).addEventListener('click', this._actionButtonClickHandler());
    }

    _actionButtonClickHandler() {
        return () => {
            let actionPrefix = this.action.IdMapLayer != null
                ? 'xp_map_layer_action_'
                : 'xp_map_action_';
            let actionHandler = window[actionPrefix + this.action.Id + '_onClick'];
            if (actionHandler) {
                actionHandler();
            }
        };
    }

    _getActionButtonTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<li>
                            <a class="btn map-menu-item" id="` + this.elementId + `" title="` + this._getTitle() + `">
                                <i class="` + this.action.Icon + `"></i>
                            </a>
                        </li>`;
        return div.firstChild;
    }

    _getTitle() {
        if (this.action.Title != null && this.action.Title != '') {
            return this.action.Title;
        }

        return this.resourcesHandler.get('SubType_' + this.action.SubType);
    }
}
